import { validateCommerceItemImageSrc, validateCommerceItemOffers, validateCommerceItemIdentifiers, validateCommerceItemCategory, } from './validatorFunctions';
import { ValidationServiceProvider } from './validationServiceSetup';
export function validateCommerceItem(data) {
    if (data === undefined) {
        return;
    }
    const registry = ValidationServiceProvider.getInstance().createEntityValidator('CommerceItem', {
        imageSrc: validateCommerceItemImageSrc,
        offers: validateCommerceItemOffers,
        identifiers: validateCommerceItemIdentifiers,
        category: validateCommerceItemCategory,
    });
    return registry.validate(data);
}
//# sourceMappingURL=entityValidators.js.map